<form class="ui search" [formGroup]="form" (mouseleave)="closeDropDown()">
  <div class="ui icon input" (click)="openDropDown()">
    <input
      class="prompt"
      type="text"
      [attr.placeholder]="placeholder"
      formControlName="value"
      (keyup)="filterOptions($event.target.value)"
      #inputValue
    />
    <i class="{{ iconName }} icon"></i>
  </div>
  <div class="ui vertical menu fluid dropdown-menu" *ngIf="isShowDropDown">
    <div
      *ngFor="let option of optionList"
      [class.active]="selectedOption === option[fieldName]"
      class="link active item"
      (click)="onSelectedOption((inputValue.value = option[fieldName]), option)"
    >
      {{ option[fieldName] }}
    </div>
  </div>
</form>
